import React from 'react'

import BaseIcon from './base/base_icon'
import nearpodIconSvg from '../../assets/components/icon/nearpod-icon.svg'
import questionIconSvg from '../../assets/components/icon/question-icon.svg'
import successIconSvg from '../../assets/components/icon/success-icon.svg'
import errorIconSvg from '../../assets/components/icon/error-icon.svg'
import mailIconSvg from '../../assets/components/icon/mail-icon.svg'
import googleIconSvg from '../../assets/components/icon/google-icon.svg'
import officeIconSvg from '../../assets/components/icon/office-icon.svg'
import bindersIconSvg from '../../assets/components/icon/binders-icon.svg'
import deleteBinderIconSvg from '../../assets/components/icon/delete-binder-icon.svg'
import checkedIconSvg from '../../assets/components/icon/checked-icon.svg'
import trashIconSvg from '../../assets/components/icon/trash-icon.svg'
import chevronIconSvg from '../../assets/components/icon/chevron-icon.svg'
import closeIconSvg from '../../assets/components/icon/close-icon.svg'
import tilesIconSvg from '../../assets/components/icon/tiles-icon.svg'
import searchIconSvg from '../../assets/components/icon/search-icon.svg'
import enlargeIconSvg from '../../assets/components/icon/enlarge-icon.svg'
import selectedIconSvg from '../../assets/components/icon/selected-icon.svg'
import wellDoneSvg from '../../assets/views/slides/activities/mp-well-done.svg'
import cleverIconSvg from '../../assets/components/icon/clever-icon.svg'
import classlinkIconSvg from '../../assets/components/icon/classlink-icon.svg'

const NearpodIcon = props => <BaseIcon src={nearpodIconSvg} {...props} />
const QuestionIcon = props => <BaseIcon src={questionIconSvg} {...props} />
const SuccessIcon = props => <BaseIcon src={successIconSvg} {...props} />
const ErrorIcon = props => <BaseIcon src={errorIconSvg} {...props} />
const MailIcon = props => <BaseIcon src={mailIconSvg} {...props} />
const GoogleIcon = props => <BaseIcon src={googleIconSvg} {...props} />
const OfficeIcon = props => <BaseIcon src={officeIconSvg} {...props} />
const BindersIcon = props => <BaseIcon src={bindersIconSvg} {...props} />
const DeleteBinderIcon = props => <BaseIcon src={deleteBinderIconSvg} {...props} />
const CheckedIcon = props => <BaseIcon src={checkedIconSvg} {...props} />
const TrashIcon = props => <BaseIcon src={trashIconSvg} {...props} />
const ChevronIcon = props => <BaseIcon src={chevronIconSvg} {...props} />
const CloseIcon = props => <BaseIcon src={closeIconSvg} {...props} />
const TilesIcon = props => <BaseIcon src={tilesIconSvg} {...props} />
const SearchIcon = props => <BaseIcon src={searchIconSvg} {...props} />
const EnlargeIcon = props => <BaseIcon src={enlargeIconSvg} {...props} />
const SelectedIcon = props => <BaseIcon src={selectedIconSvg} {...props} />
const WellDoneIcon = props => <BaseIcon src={wellDoneSvg} {...props} />
const CleverIcon = props => <BaseIcon src={cleverIconSvg} {...props} />
const ClasslinkIcon = props => <BaseIcon src={classlinkIconSvg} {...props} />

export {
	NearpodIcon,
	QuestionIcon,
	SuccessIcon,
	ErrorIcon,
	MailIcon,
	GoogleIcon,
	OfficeIcon,
	BindersIcon,
	DeleteBinderIcon,
	CheckedIcon,
	TrashIcon,
	ChevronIcon,
	CloseIcon,
	TilesIcon,
	SearchIcon,
	EnlargeIcon,
	SelectedIcon,
	WellDoneIcon,
	CleverIcon,
	ClasslinkIcon,
}
